export const GET_BOOKINGS_REQUEST = 'instalent/GET_BOOKINGS_REQUEST';
export const GET_BOOKINGS_SUCCESS = 'instalent/GET_BOOKINGS_SUCCESS';
export const GET_BOOKINGS_FAIL = 'instalent/GET_BOOKINGS_FAIL';

export const GET_CALENDER_BOOKING_REQUEST =
  'instalent/GET_CALENDER_BOOKING_REQUEST';
export const GET_CALENDER_BOOKING_SUCCESS =
  'instalent/GET_CALENDER_BOOKING_SUCCESS';
export const GET_CALENDER_BOOKING_FAIL = 'instalent/GET_CALENDER_BOOKING_FAIL';
